"use client"

import { Mail, Phone, MapPin, Facebook, Twitter, Instagram, Linkedin } from "lucide-react"
import { useTranslations, useLocale } from 'next-intl'
import { Link } from "@/i18n/navigation"

export default function Footer() {
  const t = useTranslations()
  const locale = useLocale()
  const currentYear = new Date().getFullYear()

  return (
    <footer className="w-full bg-card/50 border-t border-border transition-colors duration-300" dir={locale === 'ar' ? 'rtl' : 'ltr'}>
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 mb-8 sm:mb-12">
          {/* Brand Section */}
          <div className="space-y-3 sm:space-y-4 sm:col-span-2 lg:col-span-1">
            <div>
              <h3 className="text-xl sm:text-2xl font-bold text-foreground mb-2">Tunisia</h3>
              <p className="text-primary font-semibold">Cathago Guide</p>
            </div>
            <p className="text-muted-foreground text-sm leading-relaxed">
              {t('footer.description')}
            </p>
          </div>

{/* Quick Links */}
<div className="space-y-3 sm:space-y-4">
  <h4 className="font-semibold text-foreground text-sm sm:text-base">{t('footer.quickLinks')}</h4>
  <ul className="grid grid-cols-2 sm:grid-cols-1 lg:grid-cols-2 gap-y-2 gap-x-2 sm:gap-x-4">
    <li>
      <Link href="/states" className="text-muted-foreground hover:text-primary transition-colors text-xs sm:text-sm">
        {t('navigation.states')}
      </Link>
    </li>
    <li>
      <Link href="/destinations" className="text-muted-foreground hover:text-primary transition-colors text-xs sm:text-sm">
        {t('navigation.destinations')}
      </Link>
    </li>
    <li>
      <Link href="/hotels" className="text-muted-foreground hover:text-primary transition-colors text-xs sm:text-sm">
        {t('navigation.hotels')}
      </Link>
    </li>
    <li>
      <Link href="/restaurants" className="text-muted-foreground hover:text-primary transition-colors text-xs sm:text-sm">
        {t('navigation.restaurants')}
      </Link>
    </li>
    <li>
      <Link href="/activities" className="text-muted-foreground hover:text-primary transition-colors text-xs sm:text-sm">
        {t('navigation.activities')}
      </Link>
    </li>
    <li>
      <Link href="/events" className="text-muted-foreground hover:text-primary transition-colors text-xs sm:text-sm">
        {t('navigation.events')}
      </Link>
    </li>
    <li>
      <Link href="/festivals" className="text-muted-foreground hover:text-primary transition-colors text-xs sm:text-sm">
        {t('navigation.festivals')}
      </Link>
    </li>
    <li>
      <Link href="/monuments" className="text-muted-foreground hover:text-primary transition-colors text-xs sm:text-sm">
        {t('navigation.monuments')}
      </Link>
    </li>
    <li>
      <Link href="/museums" className="text-muted-foreground hover:text-primary transition-colors text-xs sm:text-sm">
        {t('navigation.museums')}
      </Link>
    </li>
    <li>
      <Link href="/circuits" className="text-muted-foreground hover:text-primary transition-colors text-xs sm:text-sm">
        {t('navigation.circuits')}
      </Link>
    </li>
  </ul>
</div>


          {/* Contact Info */}
          <div className="space-y-3 sm:space-y-4">
            <h4 className="font-semibold text-foreground text-sm sm:text-base">{t('navigation.contact')}</h4>
            <div className="space-y-2 sm:space-y-3" >
              <div className="flex items-start gap-2 sm:gap-3">
                <Phone className="w-4 h-4 sm:w-5 sm:h-5 text-primary mt-0.5 flex-shrink-0" />
                <div className="text-xs sm:text-sm">
                  <p className="text-muted-foreground" dir="ltr">+216 71 168 600</p>
                </div>
              </div>
              <div className="flex items-start gap-2 sm:gap-3">
                <Mail className="w-4 h-4 sm:w-5 sm:h-5 text-primary mt-0.5 flex-shrink-0" />
                <div className="text-xs sm:text-sm">
                  <p className="text-muted-foreground" dir="ltr">contact@nadas-group.com</p>
                </div>
              </div>
              <div className="flex items-start gap-2 sm:gap-3">
                <MapPin className="w-4 h-4 sm:w-5 sm:h-5 text-primary mt-0.5 flex-shrink-0" />
                <div className="text-xs sm:text-sm">
                  <p className="text-muted-foreground" dir="ltr">8 Rue Bachaya Bent Maaouia </p>
                  <p className="text-muted-foreground" dir="ltr">El Manar 1, Tunisie</p>
                </div>
              </div>
            </div>
          </div>

          {/* Social Links */}
          <div className="space-y-3 sm:space-y-4">
            <h4 className="font-semibold text-foreground text-sm sm:text-base">{t('footer.followUs')}</h4>
            <div className="flex gap-3 sm:gap-4">
              <a
                href="#"
                className="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-primary/20 flex items-center justify-center text-primary hover:bg-primary hover:text-primary-foreground transition-colors"
              >
                <Facebook className="w-4 h-4 sm:w-5 sm:h-5" />
              </a>
              <a
                href="#"
                className="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-primary/20 flex items-center justify-center text-primary hover:bg-primary hover:text-primary-foreground transition-colors"
              >
                <Twitter className="w-4 h-4 sm:w-5 sm:h-5" />
              </a>
              <a
                href="#"
                className="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-primary/20 flex items-center justify-center text-primary hover:bg-primary hover:text-primary-foreground transition-colors"
              >
                <Instagram className="w-4 h-4 sm:w-5 sm:h-5" />
              </a>
              <a
                href="#"
                className="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-primary/20 flex items-center justify-center text-primary hover:bg-primary hover:text-primary-foreground transition-colors"
              >
                <Linkedin className="w-4 h-4 sm:w-5 sm:h-5" />
              </a>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-border my-6 sm:my-8" />

        {/* Bottom Footer */}
        <div className="flex flex-col sm:flex-row justify-between items-center gap-3 sm:gap-4 text-xs sm:text-sm text-muted-foreground">
          <p>{t('footer.copyright')}</p>
          <div className="flex flex-wrap justify-center sm:justify-end gap-4 sm:gap-6">
            <a href="#" className="hover:text-primary transition-colors">
              {t('footer.privacyPolicy')}
            </a>
            <a href="#" className="hover:text-primary transition-colors">
              {t('footer.termsOfService')}
            </a>
            <a href="#" className="hover:text-primary transition-colors">
              Cookie Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}
